

<script>
  import { onMount, onDestroy, afterUpdate } from 'svelte';
  import { createEventDispatcher } from 'svelte';
  import { Capacitor } from '@capacitor/core';
  import { PushNotifications } from '@capacitor/push-notifications';
  import { Keyboard } from '@capacitor/keyboard';
  import backgroundImage from './assets/new_top_image.png';
  import { statusBarStyle } from './statusbar.js';
  import { fade } from 'svelte/transition'; 


  const dispatch = createEventDispatcher();
  const isWeb = Capacitor.isNativePlatform() ? false : true;

  let phoneNumber = '';
  let message = '';
  let isPhoneNumberValid = false;
  let isLoading = false;
  let fcmToken = null;
  let contentContainerRef;
  let inputField;
  let submitButton;
  let isFocused = false;
  let backgroundRef;
  let backgroundImageRef;
  
  let appHash = '';


  let isListening = false;
  let receivedMessage = '';
  let showDialog = false;


  $: isPhoneNumberValid = /^\d{10}$/.test(phoneNumber);

  
  
  

  async function registerForPushNotifications(retryCount = 0) {
    try {
      const { receive } = await PushNotifications.checkPermissions();
      if (receive !== 'granted') {
        const { receive } = await PushNotifications.requestPermissions();
        if (receive !== 'granted') {
          throw new Error("Push notification permissions not granted.");
        }
      }

      await PushNotifications.register();

      PushNotifications.addListener('registration', (token) => {
        console.log('FCM Token:', token.value);
        fcmToken = token.value;
      });

      PushNotifications.addListener('registrationError', (error) => {
        console.error('FCM Registration Error:', error);
        if (retryCount < 2) {
          console.log(`Retrying FCM registration. Attempt ${retryCount + 2} of 3`);
          setTimeout(() => registerForPushNotifications(retryCount + 1), 5000);
        } else {
          console.error('FCM Registration failed after 3 attempts:', error);
        }
      });

    } catch (error) {
      console.error('FCM Registration Error:', error);
      if (retryCount < 2) {
        console.log(`Retrying FCM registration. Attempt ${retryCount + 2} of 3`);
        setTimeout(() => registerForPushNotifications(retryCount + 1), 5000);
      } else {
        console.error('FCM Registration failed after 3 attempts:', error);
      }
    }
  }





async function generateAppHash() {
  if (Capacitor.isNativePlatform()) {
    try {
      const result = await new Promise((resolve, reject) => {
        if (window['cordova'] && window['cordova']['plugins'] && window['cordova']['plugins']['smsRetriever']) {
          window['cordova']['plugins']['smsRetriever']['getAppHash'](resolve, reject);
        } else {
          reject('SMS Retriever plugin not found');
        }
      });
      appHash = result;
      console.log('App Hash:', appHash);
      alert(`App Hash: ${appHash}`);
    } catch (err) {
      console.error('Error generating app hash:', err);
      alert('Failed to generate app hash. Check console for details.');
    }
  } else {
    console.log('App hash generation is only available on native platforms');
    alert('App hash generation is only available on native platforms');
  }
}



async function startListeningSMS() {
  if (Capacitor.isNativePlatform()) {
    try {
      isListening = true;
      const result = await new Promise((resolve, reject) => {
        if (window['cordova'] && window['cordova']['plugins'] && window['cordova']['plugins']['smsRetriever']) {
          window['cordova']['plugins']['smsRetriever']['startWatching'](resolve, reject);
        } else {
          reject('SMS Retriever plugin not found');
        }
      });
      isListening = false;
      receivedMessage = result.Message;
      showDialog = true;
      console.log('SMS Received:', receivedMessage);
    } catch (err) {
      isListening = false;
      console.error('Error listening for SMS:', err);
      alert('Failed to listen for SMS. Check console for details.');
    }
  } else {
    console.log('SMS listening is only available on native platforms');
    alert('SMS listening is only available on native platforms');
  }
}

function closeDialog() {
  showDialog = false;
}




onMount(async () => {
  if (!isWeb) {
    await statusBarStyle.setTransparent();

    registerForPushNotifications();

    const handleKeyboardShow = (info) => {
      isFocused = true;
      const keyboardHeight = info.keyboardHeight;
      const viewportHeight = window.innerHeight; 
      const offset = Math.min(keyboardHeight, viewportHeight * 0.5);
      contentContainerRef.style.transform = `translateY(-${offset}px)`; 
      darkenBackground();
    };

    const handleKeyboardHide = () => {
      isFocused = false;
      moveContentContainerDown();
      undarkenBackground();
    };

    Keyboard.addListener('keyboardDidShow', handleKeyboardShow);
    Keyboard.addListener('keyboardWillHide', handleKeyboardHide);

    const handleFocus = () => {
      isFocused = true;
      moveContentContainerUp();
      darkenBackground();
    };

    const handleBlur = () => {
      isFocused = false;
      moveContentContainerDown();
      undarkenBackground();
    };

    inputField.addEventListener('focus', handleFocus);
    inputField.addEventListener('blur', handleBlur);

    const handleTouchStart = (event) => {
      if (!contentContainerRef.contains(event.target) && !inputField.contains(event.target) && isFocused) {
        isFocused = false;
        moveContentContainerDown();
        undarkenBackground();
        Keyboard.hide();
      }
    };

    document.addEventListener('touchstart', handleTouchStart);

    return () => {
      Keyboard.removeAllListeners();
      inputField.removeEventListener('focus', handleFocus);
      inputField.removeEventListener('blur', handleBlur);
      document.removeEventListener('touchstart', handleTouchStart);
    };
  }
});

  onDestroy(async () => {
    if (!isWeb) {
      await resetStatusBarSettings();
    }
  });

  async function applyStatusBarSettings() {
    statusBarStyle.setTransparent();
  }
  


  function handleOTPRequest() {
    if (isWeb) {
      sendOTPForWeb();
    } else {
      sendOTPForNonWeb();
    }
  }



async function sendOTPForNonWeb() {
  if (!isPhoneNumberValid) {
    message = 'Please enter a valid mobile number';
    return;
  }
  isLoading = true;
  try {
    const response = await fetch('https://groupfruits.online/authentication/api/SendOtpMSG91/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ phone: phoneNumber })
    });
    const data = await response.json();
    if (response.ok) {
      dispatch('otpRequested', { phoneNumber, fcmToken });
    } else {
      message = data.message || "SMS sending failed. Please try after sometime.";
    }
  } catch (error) {
    message = "SMS sending failed. Please try after sometime.";
  }
  isLoading = false;
}



async function sendOTPForWeb() {
  if (!isPhoneNumberValid) {
    message = 'Please enter a valid mobile number.';
    return;
  }
  isLoading = true;
  try {
    const response = await fetch('https://groupfruits.online/authentication/api/SendOtpMSG91/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ phone: phoneNumber })
    });
    const data = await response.json();
    console.log('Response:', response);
    if (response.ok) {
      console.log('Dispatching otpRequestedWeb event');
      dispatch('otpRequestedWeb', { phoneNumber });
      return; // Exit the function after successful dispatch
    } else {
      message = data.message || "SMS sending failed. Please try after sometime.";
    }
  } catch (error) {
    console.error('Error:', error);
    message = "SMS sending failed. Please try after sometime.";
  } finally {
    isLoading = false;
  }
}

async function resetStatusBarSettings() {
  await statusBarStyle.setDefault();
}


  function moveContentContainerUp() {
    if (contentContainerRef) {
      contentContainerRef.style.transform = 'translateY(-200px)';
    }
  }

  function moveContentContainerDown() {
    if (contentContainerRef) {
      contentContainerRef.style.transform = 'translateY(0)';
    }
  }

  let backgroundOverlayRef;

  function darkenBackground() {
    if (backgroundOverlayRef) {
      backgroundOverlayRef.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'; // Semi-transparent black overlay
    }
  }

  function undarkenBackground() {
    if (backgroundOverlayRef) {
      backgroundOverlayRef.style.backgroundColor = 'rgba(0, 0, 0, 0)'; // Transparent overlay
    }
  }


  function handleSubmit(event) {
    event.preventDefault();
    handleOTPRequest();
  }

</script>


<main>

  <div class="background" bind:this={backgroundRef}>
    <div class="background-image-wrapper">
      <div class="background-image-container" bind:this={backgroundImageRef}>
        <div class="background-image" style="background-image: url({backgroundImage});"></div>
      </div>
    </div>
    <div class="background-overlay" bind:this={backgroundOverlayRef}></div>
  </div>

  <div class="content-wrapper" bind:this={contentContainerRef}>
    <div class="content">
  
		<h1>
		  Login to order now 
		</h1>

      <p>Enter your 10 digit mobile number</p>

      <form on:submit={handleSubmit}>
        <div class="input-group">
          <input
            id="phone-input"
            type="tel"
            bind:value={phoneNumber}
            maxlength="10"
            placeholder="+91"
            inputmode="numeric"
            bind:this={inputField}
          />
        </div>

        <button type="submit" class="cta-button" class:enabled={isPhoneNumberValid} disabled={!isPhoneNumberValid} bind:this={submitButton}>
          {#if isLoading}
            <div class="loader">
              <div class="loader-dot"></div>
              <div class="loader-dot"></div>
              <div class="loader-dot"></div>
            </div>
          {:else}
            Continue
          {/if}
        </button>
      </form>


<!--     <button type="button" class="hash-button" on:click={generateAppHash}>Generate App Hash</button>
	  

		<button 
		  type="button" 
		  class="listen-sms-button" 
		  on:click={startListeningSMS} 
		  disabled={isListening}
		>
		  {isListening ? 'Listening...' : 'Start Listening for SMS'}
		</button>

--> 


      {#if message}
        <div class="error-message" transition:fade>
          {message}
        </div>
      {/if}
    </div>
  </div>


{#if showDialog}
  <div class="dialog-overlay" on:click={closeDialog}>
    <div class="dialog-content" on:click|stopPropagation>
      <h2>SMS Received</h2>
      <p>{receivedMessage}</p>
      <button on:click={closeDialog}>Close</button>
    </div>
  </div>
{/if}



</main>




<style>
  * {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  main {
    font-family: 'Arial', sans-serif;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -1;
  }

  .background-image-wrapper,
  .background-image-container,
  .background-image {
    width: 100%;
    height: 100%;
  }

  .background-image {
    background-size: cover;
    background-position: top center;
    position: fixed;
    top: 0;
    left: 0;
  }

  .background-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    transition: background-color 0.3s ease-in-out;
  }

  .content-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    transition: transform 0.3s ease-in-out;
  }

  .content {
    background-color: white;
    padding: 8vw;
    border-radius: 5vw 5vw 0 0;
    text-align: center;
    box-shadow: 0 -1vw 4vw rgba(0, 0, 0, 0.1);
  }

  h1 {
    margin-bottom: 5vw;
    color: #333333;
    font-size: 5vw;
    font-weight: bold;
  }

  p {
    margin-bottom: 5vw;
    color: #333333;
    font-size: 4vw;
  }

  .input-group {
    margin-bottom: 5vw;
    position: relative;
    width: 100%;
  }

  .input-group input[type='tel'] {
    width: 100%;
    padding: 4vw;
    font-size: 4vw;
    border: 0.5vw solid #eee;
    border-radius: 3vw;
    outline: none;
    transition: border-color 0.3s;
    box-sizing: border-box;
  }

  .input-group input[type='tel']:focus {
    border-color: #D8D6D6;
  }

  .cta-button {
    width: 100%;
    background-color: #eee;
    color: #888;
    padding: 4vw;
    font-size: 4.5vw;
    font-weight: bold;
    border: none;
    border-radius: 3vw;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 0.3s, color 0.3s;
  }

  .cta-button.enabled {
    background-color: #d61f2c;
    color: white;
  }

  .error-message {
    margin-top: 4vw;
    color: #d32f2f;
    font-size: 3.5vw;
    text-align: center;
  }

  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .loader-dot {
    width: 2vw;
    height: 2vw;
    border-radius: 50%;
    background-color: #fff;
    margin: 0 1vw;
    animation: loader-dot-pulse 1s infinite ease-in-out both;
  }

  .loader-dot:nth-child(1) {
    animation-delay: -0.32s;
  }

  .loader-dot:nth-child(2) {
    animation-delay: -0.16s;
  }

  .hash-button,
  .listen-sms-button {
    margin-top: 4vw;
    width: 100%;
    background-color: #4CAF50;
    color: white;
    padding: 4vw;
    font-size: 4vw;
    border: none;
    border-radius: 3vw;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .hash-button:hover,
  .listen-sms-button:hover {
    background-color: #45a049;
  }

  .listen-sms-button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }

  .dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .dialog-content {
    background-color: white;
    padding: 5vw;
    border-radius: 2vw;
    max-width: 80%;
  }

  .dialog-content h2 {
    margin-top: 0;
    font-size: 5vw;
  }

  .dialog-content p {
    font-size: 4vw;
  }

  .dialog-content button {
    margin-top: 3vw;
    padding: 2vw 4vw;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 1vw;
    cursor: pointer;
    font-size: 4vw;
  }

  @keyframes loader-dot-pulse {
    0%, 80%, 100% {
      transform: scale(0.6);
    }
    40% {
      transform: scale(1);
    }
  }

  /* Media Queries for larger screens */
  @media (min-width: 768px) {
    .content {
      padding: 4vw;
      border-radius: 2.5vw 2.5vw 0 0;
    }

    h1 {
      font-size: 3vw;
      margin-bottom: 2.5vw;
    }

    p {
      font-size: 2vw;
      margin-bottom: 2.5vw;
    }

    .input-group input[type='tel'] {
      padding: 2vw;
      font-size: 2vw;
      border-radius: 1.5vw;
    }

    .cta-button {
      padding: 2vw;
      font-size: 2.25vw;
      border-radius: 1.5vw;
    }

    .error-message {
      font-size: 1.75vw;
      margin-top: 2vw;
    }

    .loader-dot {
      width: 1vw;
      height: 1vw;
      margin: 0 0.5vw;
    }

    .hash-button,
    .listen-sms-button {
      padding: 2vw;
      font-size: 2vw;
      border-radius: 1.5vw;
      margin-top: 2vw;
    }

    .dialog-content {
      padding: 2.5vw;
      border-radius: 1vw;
    }

    .dialog-content h2 {
      font-size: 2.5vw;
    }

    .dialog-content p {
      font-size: 2vw;
    }

    .dialog-content button {
      padding: 1vw 2vw;
      font-size: 2vw;
      border-radius: 0.5vw;
    }
  }

  @media (min-width: 1024px) {
    .content {
      padding: 2vw;
      max-width: 50vw;
      margin: 0 auto;
    }

    h1 {
      font-size: 2vw;
    }

    p {
      font-size: 1.5vw;
    }

    .input-group input[type='tel'] {
      padding: 1.5vw;
      font-size: 1.5vw;
    }

    .cta-button {
      padding: 1.5vw;
      font-size: 1.75vw;
    }

    .error-message {
      font-size: 1.25vw;
    }

    .hash-button,
    .listen-sms-button {
      padding: 1.5vw;
      font-size: 1.5vw;
    }

    .dialog-content {
      max-width: 40vw;
    }

    .dialog-content h2 {
      font-size: 2vw;
    }

    .dialog-content p {
      font-size: 1.5vw;
    }

    .dialog-content button {
      font-size: 1.5vw;
    }
  }
</style>